module.exports = __webpack_public_path__ + "static/media/noun-pipeline.c1c06ffd.svg";